import { DropDownOption } from "../interfaces/drop-down-option.interface";

export const YES_NO = [
  { id: true, displayValue: 'Yes' },
  { id: false, displayValue: 'No' },
];

export const YES_NO_WITH_NUMERIC_ID: DropDownOption[] = [
  { id: 1, displayValue: 'Yes' },
  { id: 0, displayValue: 'No' },
];
